import TextArea from "ui/common/components/input/TextArea/TextArea";
import TextField from "ui/common/components/input/TextField/TextField";
import FormGridImageInput from "./FormGridImageInput";
import { FormGridInputRoot } from "./FormGridInput.styles";
import { FormGridInputProps, FormGridInputs } from "./FormGridInput.types";
import useFormGridInput from "./hooks/useFormGridInput";

const FORM_GRID_INPUTS: FormGridInputs = {
    textarea: TextArea,
    textfield: TextField,
    image: FormGridImageInput,
};

function FormGridInput({ input, name, bold, ...inputProps }: FormGridInputProps) {
    const { value, setValue } = useFormGridInput({ name });
    const Input = FORM_GRID_INPUTS[input];

    return (
        <FormGridInputRoot className="form-grid-input" bold={bold}>
            {/* @ts-ignore - no se puede cambiar por la sugerencia de deepsource*/}
            <Input name={name} {...inputProps} value={value} onChange={setValue} />
        </FormGridInputRoot>
    );
}

export default FormGridInput;
